import { COMPANY, CONNECTION } from './config.js';
const SESSION_KEY = 'vendeySvelteSession:' + COMPANY;
export function readJson(key, fallback = null) {
  try { return JSON.parse(localStorage.getItem(key) || 'null') ?? fallback; } catch { return fallback; }
}
export function readSession() {
  const saved = readJson(SESSION_KEY);
  return saved?.company === COMPANY && saved?.warehouseId > 0 && saved?.sellerId && saved?.boxId ? saved : null;
}
export function saveSession(session) {
  const value = { ...session, company: COMPANY, token: COMPANY };
  localStorage.setItem(SESSION_KEY, JSON.stringify(value));
  const legacy = {
    gsempresaglobal: COMPANY, gstoken: COMPANY, datosPedido: JSON.stringify(CONNECTION), nombrecarpetawhatsapp: 'made_in_camana',
    gsCodigoVendedor: value.sellerId, gsNombreCaja: value.boxName, gsUsuarioCaja: value.boxUser, gsNroCaja: value.boxId,
    gsCod_Alma_Caja: value.boxSelectionId, gsDesc_Alma_Caja: value.store, gsCodAlmacen: value.warehouseId,
    nombrecaja: value.boxName, nombrevendedor: value.seller, nombrealmacen: value.store
  };
  Object.entries(legacy).forEach(([key, item]) => localStorage.setItem(key, String(item ?? '')));
  return value;
}
export function logout() {
  localStorage.removeItem(SESSION_KEY); localStorage.removeItem('vendeySvelteDraft:' + COMPANY);
  if (localStorage.getItem('gsempresaglobal') === COMPANY) {
    ['gstoken', 'gsCodigoVendedor', 'gsNombreCaja', 'gsUsuarioCaja', 'gsNroCaja', 'gsCod_Alma_Caja', 'gsCodAlmacen', 'nombrecaja', 'nombrevendedor', 'nombrealmacen'].forEach(key => localStorage.removeItem(key));
  }
}
export function readConnection() { return { ...CONNECTION }; }
